import { Jetty, Mobru, Product, Quay, TerminalPlannerBerth } from 'src/types'

export const QUAY_TYPE = {
  bollard: 'BOLLARD',
  sticky: 'STICKY'
}

export const QUAY_ROLE = {
  normal: 'NORMAL',
  layby: 'LAYBY',
  external: 'EXTERNAL'
}

export const DEFAULT_OPERATION = {
  loading: 'LOADING',
  unloading: 'UNLOADING'
}

export const INITIAL_BERTH: TerminalPlannerBerth = {
  berthId: '',
  berth: {
    _id: '',
    terminalName: '',
    terminalId: '',
    harbourName: '',
    harbourNameShort: '',
    berthName: '',
    berthNameLong: '',
    length: 0,
    width: 0,
    direction: 0,
    area: {
      type: 'Polygon',
      coordinates: []
    },
    type: ''
  },
  terminalName: '',
  startBollard: 0,
  endBollard: 0
}

export const INITIAL_QUAY: Quay = {
  name: 'New quay',
  boundingBox: [],
  center: [0, 0],
  minBollard: 0,
  maxBollard: 0,
  berths: [],
  mobrus: [],
  jetties: [],
  quayType: '',
  defaultUnloading: null,
  role: ''
}

export const INITIAL_MOBRU: Mobru = {
  name: '',
  color: '',
  bollardStart: 0,
  bollardEnd: 0,
  bollardDefaultStart: 0,
  bollardDefaultEnd: 0,
  reverseStartPlacement: false,
  products: []
}

export const INITIAL_JETTY: Jetty = {
  name: '',
  color: '',
  bollard: 0,
  bollardDefaultStart: 0,
  bollardDefaultEnd: 0,
  reverseStartPlacement: false,
  products: []
}

export const INITIAL_PRODUCT: Product = {
  product: '',
  productGroup: '',
  color: '',
  loadSpeed: 0,
  slackTimes: {
    ds: {
      prior: 0,
      after: 0
    },
    ss: {
      prior: 0,
      after: 0
    },
    barge: {
      prior: 0,
      after: 0
    }
  },
  manning: 0,
  isUnloading: false,
  exportSequenceNumber: 0,
  productUnit: 'mt'
}
